export const InputStyle =
  "bg-transparent placeholder-secondaryGray w-full border-gray rounded  text-secondaryGray font-Muli leading-tight focus:outline-none";
export const InputWidthSm = "block w-1/6 mt-2 mb-2";
export const InputWidthMd = "block w-2/6 mt-2 mb-2";
export const InputWidthLg = "block w-3/6 mt-2 mb-2";
export const InputWidthfull = "block w-full mt-2 mb-2";
